module.exports = require("axios");


/*****************
 ** WEBPACK FOOTER
 ** external "axios"
 ** module id = 2
 ** module chunks = 0
 **/